import {
  COLUMN_HEIGHT,
  HEIGHT_OF_ONE_HOUR,
  ONE_HOUR,
  SNAP_GAP,
  SNAP_INTERVAL_IN_HOURS,
} from "@miplatform/constants";
import {
  getDateWithAddedTime,
  getDateWithNewHours,
  snapAdjusted,
} from "@miplatform/utils";

export const useEventViewController = ({ top, event, onEventUpdate, zoom }) => {
  const height =
    zoom *
    snapAdjusted(event.duration ?? 1, SNAP_INTERVAL_IN_HOURS, "floor") *
    HEIGHT_OF_ONE_HOUR;

  const calculateHeight = ({
    extendedTime,
    fromBucket,
    height,
    top = 0,
    isOverLay,
  }) => {
    if (fromBucket) {
      const result = isOverLay
        ? zoom *
          snapAdjusted(
            (event.expectedDuration ?? ONE_HOUR) / ONE_HOUR,
            SNAP_INTERVAL_IN_HOURS,
            "floor"
          ) *
          HEIGHT_OF_ONE_HOUR
        : HEIGHT_OF_ONE_HOUR;

      return result;
    }

    return Math.min(
      (COLUMN_HEIGHT - top) * zoom,
      Math.max(SNAP_GAP, height + (extendedTime || 0) * HEIGHT_OF_ONE_HOUR)
    );
  };

  const onResizeStop = (_, __, ___, delta) => {
    const updatedHeight =
      Math.min(
        Math.max(
          SNAP_INTERVAL_IN_HOURS * HEIGHT_OF_ONE_HOUR,
          height + delta.height
        ),
        (COLUMN_HEIGHT - top) * zoom
      ) / zoom;

    const updates = {
      userId: event.assignedUserId,
      scheduledStartDate: event.scheduledStartDate,
      scheduledEndDate: getDateWithAddedTime(
        getDateWithNewHours(
          event.scheduledStartDate,
          (top + updatedHeight) / HEIGHT_OF_ONE_HOUR
        ),
        { h: -event.delayedTime, s: -1 }
      ),
    };

    onEventUpdate(event, updates);
  };

  return {
    height,
    onResizeStop,
    calculateHeight,
  };
};
